import React from 'react';
import { ModuloContextProvider } from './context/ModuloContext';
import { ModuloContent } from './ModuloContent';

export const Modulo: React.FC = () => {
  return (
    <ModuloContextProvider>
      <ModuloContent />
    </ModuloContextProvider>
  );
};
